var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "custom-multiselect-style placeholder-italic",
      class: _vm.getParentCustom,
    },
    [
      _c(
        "multiselect",
        _vm._b(
          {
            class: _vm.classes,
            attrs: {
              options: _vm.options,
              searchable: true,
              placeholder: _vm.placeholder,
              loading: _vm.internalIsLoading,
              multiple: _vm.multiple,
              label: "label",
              "track-by": "value",
            },
            on: {
              input: _vm.updateValue,
              "search-change": _vm.handleSearch,
              close: _vm.handleClose,
            },
            model: {
              value: _vm.internalValue,
              callback: function ($$v) {
                _vm.internalValue = $$v
              },
              expression: "internalValue",
            },
          },
          "multiselect",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }